import { IconButton, Typography } from '@material-ui/core'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { area } from '@turf/turf'
import L from 'leaflet'
import { debounce } from 'lodash'
import { Control, Controller } from 'react-hook-form'
import { ListChildComponentProps } from 'react-window'

import InputText from '@/components/input-text'
import { DEFAULT_COLUMN } from '@/pages/projects-form/constants'
import { DefaultProjectFormData } from '@/pages/projects-form/contexts/project-context'
import { GeoJSONObject } from '@/types/geospatial'

import { useStyles } from './styles'

interface InputRowProps {
  features: Array<GeoJSONObject['features'][number] & { featureId: string }>
  control: Control<DefaultProjectFormData>
  currentRegionIndex: number
  currentColumn: string | null
  removeFeatureFromGeoJSON: (index: number, featureId: string) => void
  setCurrentBounds: (bounds: L.LatLngBounds) => void
}

export function InputRow({
  index,
  style,
  data: {
    features,
    control,
    currentRegionIndex,
    currentColumn,
    removeFeatureFromGeoJSON,
    setCurrentBounds,
  },
}: ListChildComponentProps<InputRowProps>) {
  const classes = useStyles()

  return (
    <div style={style} className={classes.container}>
      <Controller
        key={currentColumn}
        control={control}
        name={`regions.${currentRegionIndex}.geojson.features.${index}.properties.${
          currentColumn || DEFAULT_COLUMN
        }`}
        defaultValue={features[index].properties[currentColumn!] ?? ''}
        render={({
          field: { value, onChange, name },
          fieldState: { error },
        }) => (
          <InputText
            id={features[index].featureId}
            className={classes.input}
            name={name}
            defaultValue={String(value)}
            onChange={debounce(onChange, 500)}
            onFocus={debounce(
              () => setCurrentBounds(L.geoJSON(features[index]).getBounds()),
              100,
            )}
            error={!!error}
          />
        )}
      />

      <div className={classes.area}>
        <Typography className='MuiOutlinedInput-notchedOutline MuiInputBase-root'>
          {(area(features[index] as any) / 10000)
            .toFixed(2)
            .toString()
            .replace('.', ',')}{' '}
          ha
        </Typography>
      </div>

      <div className={classes.removeButton}>
        <IconButton
          aria-label={`Remover talhão da feature ${features[index].featureId}`}
          onClick={() =>
            removeFeatureFromGeoJSON(index, features[index].properties.id)
          }
        >
          <DeleteOutlineIcon />
        </IconButton>
      </div>
    </div>
  )
}
